export const siteInfo = {
  name: "继母与继姐漫画",
  officialSite: "继母与继姐漫画官网",
  tagline: "家不是血缘，而是愿意靠近的心",
  intro:
    "《继母与继姐》是一部围绕重组家庭展开的温情成长漫画。父母离异后的少年林屿随父亲搬进新家，面对温柔的继母苏婉与有些疏离的继姐苏念，从陌生、试探到理解、并肩，最终真正成为一家人。本页为角色关系聚合指南，帮你快速理清主角、继母、继姐的关系与互动逻辑。",
};

export interface Character {
  id: string;
  name: string;
  tag: string;
  age: string;
  role: string;
  quote: string;
  traits: string[];
  description: string;
  image: string;
  accent: "primary" | "accent" | "secondary";
}

export const protagonist: Character = {
  id: "protagonist",
  name: "林屿",
  tag: "主角",
  age: "17 岁 · 高二学生",
  role: "故事主角 · 从抗拒到接纳的少年",
  quote: "我曾经以为家只剩一半，后来才知道，原来它还能多出两倍。",
  traits: ["外冷内热", "沉默但有担当", "擅长做饭", "笨拙地关心人"],
  description:
    "林屿是故事的核心主角。父母离异后，他跟随父亲林正国搬入继母苏婉的家。初来乍到时，他对新家庭充满戒备，习惯一个人扛下所有情绪。随着与继母、继姐的日常相处，他渐渐学会表达、学会信任，也成为连接两个家庭最重要的纽带。",
  image:
    "https://readdy.ai/api/search-image?query=Anime%20style%20character%20bust%20portrait%20of%20a%20cheerful%20teenage%20boy%20around%20seventeen%20with%20short%20tousled%20dark%20hair%20and%20warm%20honest%20eyes%2C%20wearing%20a%20simple%20white%20shirt%2C%20soft%20cream%20studio%20background%20with%20subtle%20terracotta%20glow%2C%20clean%20painterly%20anime%20illustration%2C%20gentle%20smile%2C%20no%20text&width=640&height=800&seq=protagonist-01&orientation=portrait",
  accent: "primary",
};

export const characters: Character[] = [
  {
    id: "stepmother",
    name: "苏婉",
    tag: "继母",
    age: "43 岁 · 独立设计师",
    role: "温柔包容的继母 · 家的守护者",
    quote: "我不求你们立刻喊我妈妈，只希望这个家，能让每个人都安心。",
    traits: ["温柔坚定", "心思细腻", "热爱生活", "擅长倾听"],
    description:
      "苏婉是林屿的继母，独立设计师出身，性格温柔却内心坚定。她尊重继子的边界，不急于建立亲密，而是用一餐一饭、一次陪伴慢慢融化隔阂。她也是整个重组家庭里最稳定的情感锚点，面对女儿苏念的误解始终耐心。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20character%20bust%20portrait%20of%20a%20kind%20elegant%20stepmother%20in%20her%20early%20forties%20with%20shoulder-length%20soft%20brown%20hair%20and%20a%20gentle%20warm%20smile%2C%20wearing%20a%20soft%20beige%20cardigan%2C%20cream%20studio%20background%20with%20warm%20amber%20glow%2C%20clean%20painterly%20anime%20illustration%2C%20no%20text&width=640&height=800&seq=stepmother-01&orientation=portrait",
    accent: "accent",
  },
  {
    id: "stepsister",
    name: "苏念",
    tag: "继姐",
    age: "24 岁 · 职场新人",
    role: "外冷内热的继姐 · 从疏离到并肩",
    quote: "一开始我以为多了一个陌生人，后来才发现，多了一个家人。",
    traits: ["独立要强", "外冷内热", "工作认真", "口是心非"],
    description:
      "苏念是苏婉的女儿，也是林屿的继姐。大学毕业后初入职场，独立要强，对突然到来的继弟起初有些疏离和别扭。她习惯用冷漠伪装不安，却在一次次共同经历中被林屿的真诚打动，逐渐成为亦姐亦友、彼此照应的存在。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20character%20bust%20portrait%20of%20a%20calm%20composed%20stepsister%20in%20her%20early%20twenties%20with%20long%20dark%20hair%20and%20a%20subtle%20reserved%20smile%2C%20wearing%20a%20sage%20green%20blouse%2C%20cream%20studio%20background%20with%20soft%20amber%20accent%2C%20clean%20painterly%20anime%20illustration%2C%20no%20text&width=640&height=800&seq=stepsister-01&orientation=portrait",
    accent: "secondary",
  },
  {
    id: "father",
    name: "林正国",
    tag: "父亲",
    age: "49 岁 · 外科医生",
    role: "沉默内敛的父亲 · 牵起两家的手",
    quote: "家里的事，慢慢来，都会好起来的。",
    traits: ["沉稳可靠", "不善言辞", "职业操守强", "默默付出"],
    description:
      "林正国是林屿的父亲，一位外科医生，也是重组家庭中连接两方的桥梁。他沉默内敛、不擅长表达情感，却始终用行动守护着家人。他与继女苏念的关系从客气到信任，成为故事中温暖而克制的支线。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20character%20bust%20portrait%20of%20a%20kind%20middle-aged%20father%20with%20glasses%20and%20a%20patient%20warm%20smile%2C%20wearing%20a%20light%20collared%20shirt%2C%20cream%20studio%20background%2C%20warm%20neutral%20tones%2C%20clean%20painterly%20anime%20illustration%2C%20no%20text&width=640&height=800&seq=father-01&orientation=portrait",
    accent: "secondary",
  },
];

export const supportingCharacters: Character[] = [
  {
    id: "grandma",
    name: "周奶奶",
    tag: "邻居",
    age: "72 岁",
    role: "社区热心奶奶",
    quote: "一家人哪有那么多讲究，多盛一碗饭就是了。",
    traits: ["热心肠", "爱张罗", "很会聊天"],
    description: "住在隔壁的老邻居，是重组家庭最忠实的见证者与助攻手。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20a%20warm%20elderly%20grandmother%20neighbor%20with%20gray%20hair%20in%20a%20bun%20and%20a%20kind%20smile%2C%20cream%20background%2C%20soft%20warm%20tones%2C%20clean%20painterly%20anime%20illustration%2C%20no%20text&width=480&height=600&seq=grandma-01&orientation=portrait",
    accent: "primary",
  },
  {
    id: "friend",
    name: "陈晓月",
    tag: "闺蜜",
    age: "17 岁",
    role: "林屿同学兼好友",
    quote: "你笑起来其实挺好看的，多笑笑嘛。",
    traits: ["开朗", "大大咧咧", "讲义气"],
    description: "林屿的同班好友，是他在新环境里的一抹亮色。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20a%20lively%20cheerful%20high%20school%20girl%20classmate%20with%20twin%20tails%20and%20a%20bright%20grin%2C%20cream%20background%2C%20warm%20amber%20tones%2C%20clean%20painterly%20anime%20illustration%2C%20no%20text&width=480&height=600&seq=friend-01&orientation=portrait",
    accent: "accent",
  },
];

export interface RelationPair {
  a: string;
  b: string;
  type: string;
  keyword: string;
  tone: "warm" | "cool" | "neutral";
  description: string;
}

export const relationPairs: RelationPair[] = [
  {
    a: "林屿",
    b: "苏婉",
    type: "继母子",
    keyword: "从客套到信任",
    tone: "warm",
    description:
      "最初双方都小心翼翼，苏婉用一餐一饭与耐心陪伴，慢慢消融林屿的戒备，成为他最信任的家人。",
  },
  {
    a: "林屿",
    b: "苏念",
    type: "继姐弟",
    keyword: "从疏离到并肩",
    tone: "cool",
    description:
      "全篇关系主线。初遇时的别扭与试探，在一次次共同经历中转化为亦姐亦友的默契与守护。",
  },
  {
    a: "苏婉",
    b: "苏念",
    type: "母女",
    keyword: "深藏的爱与误解",
    tone: "warm",
    description:
      "母女之间隔着未说出口的爱。苏念曾误解母亲的再婚，后来才懂她一直在为自己留一盏灯。",
  },
  {
    a: "林正国",
    b: "苏念",
    type: "继父女",
    keyword: "从客气到信任",
    tone: "neutral",
    description:
      "沉默的继父用稳重可靠一点点赢得苏念的信任，是重组家庭中最克制的温情支线。",
  },
  {
    a: "林屿",
    b: "林正国",
    type: "父子",
    keyword: "沉默的理解",
    tone: "cool",
    description:
      "父子都不擅长表达，却在生活的细节里彼此成全，林正国的行动成为林屿安心的底色。",
  },
];

export interface StoryArc {
  step: string;
  title: string;
  keyword: string;
  description: string;
}

export const storyArcs: StoryArc[] = [
  {
    step: "01",
    title: "陌生的屋檐",
    keyword: "试探与分寸",
    description:
      "林屿随父亲搬进新家，与继母、继姐第一次同住。三人心怀善意却各怀不安，处处克制，生怕打扰彼此。",
  },
  {
    step: "02",
    title: "微光与试探",
    keyword: "细节与善意",
    description:
      "一碗加糖的粥、一把留好的伞、一句别扭的关心，微小的善意像光，一点点照亮彼此的边界。",
  },
  {
    step: "03",
    title: "共渡的风浪",
    keyword: "并肩与信任",
    description:
      "一场家庭风波让四人不得不站在一起。林屿的担当、苏婉的坚定、苏念的柔软被同时看见，关系悄然升温。",
  },
  {
    step: "04",
    title: "成为一家人",
    keyword: "接纳与归属",
    description:
      "从客套到信赖，从疏离到并肩。他们终于明白：家不是血缘，而是愿意靠近的心。",
  },
];

export interface RecommendItem {
  title: string;
  category: string;
  summary: string;
  image: string;
}

export const recommendations: RecommendItem[] = [
  {
    title: "主角林屿的成长全解析",
    category: "角色解读",
    summary: "从抗拒到接纳，林屿如何一步步成为连接两个家庭的纽带。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20slice-of-life%20manga%20scene%20of%20a%20teenage%20boy%20growing%20up%20in%20a%20cozy%20family%20home%2C%20soft%20cream%20and%20terracotta%20palette%2C%20painterly%20anime%20illustration%2C%20warm%20light%2C%20no%20text&width=800&height=520&seq=recommend-growth&orientation=landscape",
  },
  {
    title: "继母苏婉的温柔哲学",
    category: "角色解读",
    summary: "不急于成为妈妈，却用一餐一饭守护整座屋檐。",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20manga%20scene%20of%20a%20gentle%20mother%20figure%20cooking%20in%20a%20warm%20sunlit%20kitchen%2C%20cream%20and%20amber%20palette%2C%20painterly%20anime%20illustration%2C%20no%20text&width=800&height=520&seq=recommend-mom&orientation=landscape",
  },
  {
    title: "继姐苏念的别扭与柔软",
    category: "角色解读",
    summary: "口是心非的背后，是她一点一点放下的心墙。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20manga%20scene%20of%20a%20composed%20young%20woman%20sitting%20by%20a%20window%20with%20a%20book%2C%20soft%20cream%20and%20sage%20palette%2C%20painterly%20anime%20illustration%2C%20soft%20light%2C%20no%20text&width=800&height=520&seq=recommend-sis&orientation=landscape",
  },
  {
    title: "名场面盘点：那些没说出口的关心",
    category: "剧情盘点",
    summary: "五个让人眼眶一热的瞬间，读懂重组家庭的温柔。",
    image:
      "https://readdy.ai/api/search-image?query=Heartwarming%20manga%20scene%20of%20a%20blended%20family%20having%20dinner%20together%20around%20a%20round%20table%2C%20soft%20warm%20lamplight%2C%20cream%20terracotta%20palette%2C%20painterly%20anime%20illustration%2C%20no%20text&width=800&height=520&seq=recommend-scenes&orientation=landscape",
  },
  {
    title: "关系发展时间线整理",
    category: "剧情梳理",
    summary: "一图看清主角、继母、继姐之间每一段关系的变化节点。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20manga%20scene%20of%20two%20silhouettes%20walking%20home%20side%20by%20side%20under%20evening%20light%2C%20cream%20and%20terracotta%20palette%2C%20painterly%20anime%20illustration%2C%20no%20text&width=800&height=520&seq=recommend-timeline&orientation=landscape",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "继母与继姐漫画的主要看点是什么？",
    a: "这部漫画的核心是重组家庭里的温情成长。主角林屿与继母苏婉、继姐苏念从陌生隔阂到真正成为一家人，细腻刻画了「家人不是血缘、而是愿意靠近的心」这一主题。名场面多在细节与对话之间，适合喜欢细腻家庭向故事与情感成长的读者。",
  },
  {
    q: "主角林屿的人物设定是怎样的？",
    a: "林屿是17岁的高二学生，父母离异后随父亲搬入继母家。他外冷内热、沉默但有担当，擅长做饭，习惯笨拙地关心人。随着剧情推进，他从抗拒到接纳，成为连接两个家庭最重要的纽带。",
  },
  {
    q: "继母和继姐的角色设定分别是什么？",
    a: "继母苏婉是43岁的独立设计师，温柔坚定、心思细腻，尊重继子边界，是家庭最稳定的情感锚点。继姐苏念是24岁的职场新人，独立要强、外冷内热，习惯用冷漠伪装不安，是全书关系主线中的关键角色。",
  },
  {
    q: "继母、继姐和主角之间的关系是怎样发展的？",
    a: "全书以林屿与继姐苏念的「从疏离到并肩」为主线，辅以林屿与继母苏婉「从客套到信任」的支线。关系大致经历陌生试探、细节融化、共渡风浪、真正成为家人四个阶段，节奏细腻不拖沓。",
  },
  {
    q: "继母与继姐漫画更新频率如何？是否已完结？",
    a: "漫画采用连载制，具体更新进度与完结状态以各连载平台首页为准。本页作为角色关系指南，专注整理人物设定与关系脉络，追更进度请以官方平台发布信息为准。",
  },
  {
    q: "这部漫画适合什么样的读者？",
    a: "适合喜欢家庭向、温情成长题材的读者，也适合关注细腻人物关系与日常治愈氛围的观众。没有激烈冲突，胜在真实、温柔、后劲十足，尤其适合想读点「暖心故事」的人群。",
  },
];

export const testimonials = [
  {
    name: "追更读者 · 小北",
    content: "把每个角色都写活了，尤其是继姐那句口是心非，太真实了。",
  },
  {
    name: "漫画爱好者 · 阿茶",
    content: "关系梳理得很清楚，看完这篇再去补漫画，体验完全不同。",
  },
  {
    name: "新入坑观众 · 木棉",
    content: "一开始是冲着人物关系图来的，结果被剧情感动到。",
  },
];